import React from 'react';
import {
  Users, DollarSign, FileText, TrendingUp, Calendar, Filter, Download, RefreshCw, CheckCircle, XCircle, Clock, Search, Mail, Phone, Building, CreditCard, Percent, AlertTriangle, Check, X, Edit2, Save, Wallet, Send, ArrowRight, Banknote, Bell, Trash2, Eye
} from 'lucide-react';
import { useSuperAdminContext } from '../SuperAdminContext';

export default function FeesTab() {
  const ctx = useSuperAdminContext();
  const { activeTab, editingFee, fetchMerchantFees, handleUpdateFee, merchantFees, newFeeValue, setEditingFee, setNewFeeValue } = ctx;

  return (
    <>
            {activeTab === 'fees' && (
              <div className="fees-content">
                <div className="content-header">
                  <h2>
                    <Percent size={24} />
                    Merchant Fee Management
                  </h2>
                  <button className="btn-secondary" onClick={fetchMerchantFees}>
                    <RefreshCw size={16} /> Refresh
                  </button>
                </div>

                <div className="fee-info-banner">
                  <AlertTriangle size={16} />
                  <span>Platform fee range: 1% - 5%. This fee is deducted from each transaction.</span>
                </div>

                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Business Name</th>
                        <th>Email</th>
                        <th>Current Fee %</th>
                        <th>Bank Verified</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {merchantFees.map((merchant) => (
                        <tr key={merchant.id}>
                          <td>
                            <div className="user-info">
                              <Building size={16} />
                              {merchant.business_name}
                            </div>
                          </td>
                          <td>{merchant.email}</td>
                          <td>
                            {editingFee === merchant.id ? (
                              <div className="fee-edit-input">
                                <input
                                  type="number"
                                  min="1"
                                  max="5"
                                  step="0.1"
                                  value={newFeeValue}
                                  onChange={(e) => setNewFeeValue(e.target.value)}
                                  placeholder={merchant.platform_fee_percentage}
                                />
                                <span>%</span>
                              </div>
                            ) : (
                              <span className="fee-value">{merchant.platform_fee_percentage || 2.0}%</span>
                            )}
                          </td>
                          <td>
                            {merchant.bank_account_verified ? (
                              <CheckCircle size={20} className="icon-success" />
                            ) : (
                              <XCircle size={20} className="icon-danger" />
                            )}
                          </td>
                          <td>
                            <span className={`badge badge-${merchant.subscription_status || 'active'}`}>
                              {merchant.subscription_status || 'Active'}
                            </span>
                          </td>
                          <td>
                            {editingFee === merchant.id ? (
                              <div className="action-buttons">
                                <button 
                                  className="btn-small btn-success"
                                  onClick={() => handleUpdateFee(merchant.id)}
                                  disabled={!newFeeValue || parseFloat(newFeeValue) < 1 || parseFloat(newFeeValue) > 5}
                                >
                                  <Save size={14} /> Save
                                </button>
                                <button 
                                  className="btn-small btn-secondary"
                                  onClick={() => {
                                    setEditingFee(null);
                                    setNewFeeValue('');
                                  }}
                                >
                                  Cancel
                                </button>
                              </div>
                            ) : (
                              <button 
                                className="btn-small btn-primary"
                                onClick={() => {
                                  setEditingFee(merchant.id);
                                  setNewFeeValue(merchant.platform_fee_percentage?.toString() || '2.0');
                                }}
                              >
                                <Edit2 size={14} /> Edit Fee
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
    </>
  );
}
